import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { HttpNewService } from '../application/http-new.service';
import { AuthService } from '../auth.service';
import type {
    ICaptcha,
    ICaptchaData,
    IResponseVerifyCaptcha,
} from './interfaces';

export type { ICaptcha } from './interfaces';

@Injectable({
    providedIn: 'root',
})
export class CaptchaService {
    public constructor(
        private http: HttpNewService,
        private auth: AuthService,
    ) {}

    /**
     * Создать и получить капчу
     * @param parameters
     * @returns {Observable<IAbonement[]>}
     **/
    public fetchCaptcha(): Promise<ICaptcha> {
        return lastValueFrom(this.http.get<ICaptcha>('/captcha/create'));
    }

    /** Проверить капчу */
    public verifyCaptcha(
        captchaData: ICaptchaData,
    ): Observable<IResponseVerifyCaptcha> {
        return this.http.post<IResponseVerifyCaptcha>('/captcha/verify', {
            id: captchaData.id,
            value: captchaData.value,
        });
    }

    // Теперь верификация капчи вызывается и происходит на беке при регистрации, так что закомментировала пока что
    // /**
    //  * Создать и получить капчу
    //  * @param parameters
    //  * @returns {Observable<IAbonement[]>}
    //  **/
    // public verifyCaptcha(
    //     id: number,
    //     value: string
    // ): Promise<CaptchaVerifyResult> {
    //     const data = {
    //         id,
    //         value,
    //     };

    //     return lastValueFrom<CaptchaVerifyResult>(
    //         this.http.post('/api/captcha/verify', data).pipe(first())
    //     );
    // }
}
